function _s(o, i, p, l) {
    void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px")),
            i <= e
                ? ((o.style.height = ""),
                    (o.style.paddingTop = ""),
                    (o.style.paddingBottom = ""),
                    (o.style.marginTop = ""),
                    (o.style.marginBottom = ""),
                    (o.style.overflow = ""),
                    l || (o.style.display = "none"),
                    "function" == typeof p && p())
                : window.requestAnimationFrame(t);
    });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
    (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
    }),
    (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
    });

class MainProduct extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSlider();
        this.calculateShipping();

        if (this.querySelector('.tabs-section__item-title')) {
            this.querySelectorAll(".faq-item-title").forEach((button) => {
                button.addEventListener("click", this.toggleFaqItem.bind(this));
            });
        }

        if (this.querySelector('.product-form__quantity')) {
            this.addEventListener("change", this.updateQuantityForm.bind(this));
        }

        window.addEventListener('scroll', this.showOverlay.bind(this));

        if (this.querySelector('.product-form__bundle-item')) {
            this.querySelectorAll('.product-form__bundle-item').forEach((item) => {
                item.addEventListener('click', this.changeBundleItem.bind(this));
            });
        }

        if (document.querySelector('.bottom-bar__product-submit')) {
            document.querySelector('.bottom-bar__product-submit button').addEventListener('click', function (e) {
                document.querySelector('.product-form-main-good .product-form__add-button .button').click();
            })
        }

        if (document.querySelector('.product-form__quantity')) {
            const checked = this.querySelector('.product-form__quantity input:checked+label');
            if (checked) {
                const discounted = checked.querySelector('.product-form__quantity-item-price-discounted')?.textContent || '';
                const original = checked.querySelector('.product-form__quantity-item-price-original')?.textContent || '';
                document.querySelectorAll('[variant-price-change]').forEach((el) => {
                    el.innerHTML = original && original !== discounted ? `${discounted} <s>${original}</s>` : discounted;
                })
            }
        }

        if (this.querySelector('.product-form__bundle-navigation')) {
            this.querySelectorAll('.product-form__bundle-navigation .navigation-button').forEach((btn) => {
                btn.addEventListener('click', this.changeBundleNavigation.bind(this));
            });
        }
    }

    changeBundleNavigation(e) {
        const btn = e.currentTarget || e.target.closest('.navigation-button');
        if (!btn) return;

        const productId = btn.dataset.productId;
        if (!productId) return;

        this.querySelectorAll('.product-form__bundle-navigation .navigation-button')
            .forEach(b => b.classList.remove('active', 'is-active'));
        btn.classList.add('active', 'is-active');

        const current = this.querySelector('.product-form__bundle-current');
        current?.classList.remove('active', 'is-active');

        const bundles = this.querySelectorAll('.product-form__bundle-bundle.product-form__bundle-item');
        bundles.forEach(b => {
            b.classList.add('hidden');
            b.classList.remove('is-active', 'active');
        });

        const targetBundle = this.querySelector(`.product-form__bundle-bundle[data-product-id="${productId}"]`);
        if (targetBundle) {
            targetBundle.classList.remove('hidden');
            targetBundle.classList.add('is-active');
            this.changeBundleItem({ target: targetBundle });
        }
    }

    updateQuantityForm(e) {
        let selectedInput = e.target;
        let InputId = selectedInput.getAttribute("id");
        let label = this.querySelector(`label[for="${InputId}"]`);
        let discounted = label.querySelector('.product-form__quantity-item-price-discounted')?.textContent || '';
        let original = label.querySelector('.product-form__quantity-item-price-original')?.textContent || '';
        document.querySelectorAll('[variant-price-change]').forEach((el) => {
            el.innerHTML = original && original !== discounted ? `${discounted} <s>${original}</s>` : discounted;
        })
    }

    showOverlay() {
        let productForm = document.querySelector('.product-form-main-good');
        let bottomBar = document.querySelector('.bottom-bar');

        if (productForm) {
            let productFormRect = productForm.getBoundingClientRect();
            if (productFormRect.top < window.innerHeight && productFormRect.bottom >= 0) {
                bottomBar.classList.remove('active');
            }
            else {
                if (window.scrollY > window.innerHeight) {
                    bottomBar.classList.add('active');
                }
                else {
                    bottomBar.classList.remove('active');
                }
            }
        }
    }

    changeQuantitySubmit(e) {
        let quantity = this.querySelector(
            '.product-form-main-good [name="quantity"]'
        ).value;

        let priceValue = this.querySelector('.product-form__price--sale[variant-price-change]')
            .textContent;

        priceValue = priceValue.replace('€', '');
        priceValue = priceValue.replace(',', '.');
        priceValue = parseFloat(priceValue);
        priceValue = priceValue * quantity;
        priceValue = priceValue.toFixed(2);

        this.querySelectorAll('.product-form__price--sale[variant-price-change]').forEach((el) => {
            el.textContent = '€' + priceValue;
        });
        console.log(priceValue);

    }

    calculateShipping() {
        if (this.querySelector(".product-form__reassurance")) {
            let shipping_date = new Date(new Date().getTime());

            let shipping_delay = parseInt(
                this.querySelector(".product-form__reassurance").getAttribute(
                    "data-shipping-delay"
                )
            );
            if (shipping_delay == null) {
                shipping_delay = parseInt(
                    this.querySelector(".product-form__reassurance ").getAttribute(
                        "data-shipping-delay"
                    )
                );
            }

            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            let shipping_date_format = shipping_date.toLocaleDateString("fr-FR", {
                weekday: "long",
                day: "numeric",
                month: "long",
            });

            for (
                let i = 0;
                i < document.querySelectorAll(".product-form__reassurance").length;
                i++
            ) {
                let html = document.querySelectorAll(".product-form__reassurance")[i]
                    .innerHTML;
                if (html.indexOf("[date]") > -1) {
                    document.querySelectorAll(".product-form__reassurance")[i].innerHTML =
                        html.replace("[date]", shipping_date_format);
                }
            }
        }
    }

    initSlider() {
        const thumbsSwiper = new Swiper(this.querySelector('.swiper-thumb'), {
            slidesPerView: "auto",
            direction: "vertical",
            spaceBetween: 10,
            slideToClickedSlide: true,
        });

        const swiper = new Swiper(this.querySelector('.swiper-main'), {
            slidesPerView: 1,
            spaceBetween: 10,
            slideToClickedSlide: true,
            navigation: {
                nextEl: this.querySelector('.swiper-main .swiper-button-next'),
                prevEl: this.querySelector('.swiper-main .swiper-button-prev'),
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });

        if (this.querySelector('.swiper-pack')) {
            const swiperPack = new Swiper(this.querySelector('.swiper-pack'), {
                slidesPerView: 'auto',
                pagination: {
                    el: this.querySelector('.swiper-pack .swiper-pagination'),
                    clickable: true,
                },
            });
        }

        if (this.querySelector('.swiper.swiper-pack-item')) {
            const swiperPackItem = new Swiper(this.querySelector('.swiper.swiper-pack-item'), {
                slidesPerView: 'auto',
                spaceBetween: 6,
                pagination: {
                    el: this.querySelector('.product-form__pack-header .swiper-pagination'),
                    clickable: true,
                },
            });
        }

        if (this.querySelector('.swiper.swiper-complementary')) {
            const swiperPackComplementary = new Swiper(this.querySelector('.swiper.swiper-complementary'), {
                slidesPerView: 'auto',
                spaceBetween: 10,
                pagination: {
                    el: this.querySelector('.product-form__complementary .swiper-pagination'),
                    clickable: true,
                },
            });
        }
    }

    changeBundleItem(e) {
        let currentItem = e.target.closest('.product-form__bundle-item');
        if (!currentItem) return;

        const nav = this.querySelector('.product-form__bundle-navigation');
        const hasNav = !!nav;
        const currentCard = this.querySelector('.product-form__bundle-current');
        const bundles = this.querySelectorAll('.product-form__bundle-bundle.product-form__bundle-item');

        this.querySelectorAll('.product-form__bundle-item').forEach((item) => {
            item.classList.remove('active', 'is-active');
        });

        if (hasNav) {
            if (currentItem.classList.contains('product-form__bundle-current')) {
                currentCard?.classList.add('active', 'is-active');
                bundles.forEach(b => {
                    b.classList.remove('active', 'is-active');
                });
            } else {
                const pid = currentItem.dataset.productId;
                nav.querySelectorAll('.navigation-button').forEach(b => {
                    const isTarget = b.dataset.productId === pid;
                    b.classList.toggle('active', isTarget);
                    b.classList.toggle('is-active', isTarget);
                });
                currentCard?.classList.remove('active', 'is-active');
                bundles.forEach(b => {
                    const isTarget = b === currentItem;
                    b.classList.toggle('is-active', isTarget);
                    if (isTarget) b.classList.add('active');
                });
            }
        } else {
            currentItem.classList.add('active');
        }

        console.log(currentItem);

        let discounted = currentItem.querySelector('.product-card__price--discounted')?.textContent || '';
        let original = currentItem.querySelector('.product-card__price--original')?.textContent || '';

        if (currentItem.classList.contains('product-form__bundle-bundle')) {
            this.querySelector('.product-form-main-good [name="quantity"]').value = 1;
            this.querySelector('.product-form-main-good [name="product_id"]').value = currentItem.dataset.productId;
            this.querySelector('.product-form-main-good [name="product-id"]').value = currentItem.dataset.productId;
            this.querySelector('.product-form-main-good [name="id"]').value = currentItem.dataset.variantId;
            document.querySelectorAll('[variant-price-change]').forEach((el) => {
                el.innerHTML = original && original !== discounted ? `${discounted} <s>${original}</s>` : discounted;
            });
            document.querySelector('.bottom-bar__product-details.custom')?.classList.remove('hidden');
            document.querySelector('.bottom-bar__product-details.original')?.classList.add('hidden');
        } else {
            this.querySelector('.product-form-main-good [name="quantity"]').value =
                document.querySelector('.product-form__bundle-current [name="quantity"]').value;
            this.querySelector('.product-form-main-good [name="product_id"]').value = currentItem.dataset.productId;
            this.querySelector('.product-form-main-good [name="product-id"]').value = currentItem.dataset.productId;
            this.querySelector('.product-form-main-good [name="id"]').value = currentItem.dataset.variantId;
            document.querySelectorAll('[variant-price-change]').forEach((el) => {
                el.innerHTML = original && original !== discounted ? `${discounted} <s>${original}</s>` : discounted;
            });
            document.querySelector('.bottom-bar__product-details.custom')?.classList.add('hidden');
            document.querySelector('.bottom-bar__product-details.original')?.classList.remove('hidden');
            this.changeQuantitySubmit();
        }
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', MainProduct);

window.addEventListener('load', () => {
    document.querySelectorAll('.product-form__pack-item-submit button').forEach((component) => {
        component.addEventListener('click', (event) => {
            let id = component.dataset.variantId;

            let selections_items = [];
            selections_items.push({
                id: Number(id),
                quantity: Number(1)
            })

            let miniCart = document.querySelector('mini-cart');

            const data = {
                items: selections_items
            }
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log('Success:', data);

                    if (miniCart) {
                        miniCart.renderContents(response);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        });
    });
});
